import { render } from "./BayerPayment.vue?vue&type=template&id=4a20bc66&scoped=true"
import script from "./BayerPayment.vue?vue&type=script&lang=js"
export * from "./BayerPayment.vue?vue&type=script&lang=js"

import "./BayerPayment.vue?vue&type=style&index=0&id=4a20bc66&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a20bc66"]])

export default __exports__